export const driverFullname = (driver) => {
  const { employee } = driver;
  if (employee) {
    let { employee } = driver;
    return `${employee.Title} ${employee.Name}`;
  }
  return driver.employee_id;
};

const ones = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
];

const teens = [
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const tens = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

function numberToWords(num) {
  if (num === 100) return "One Hundred";

  if (num < 10) return ones[num];

  if (num < 20) return teens[num - 10];

  const ten = Math.floor(num / 10);
  const one = num % 10;

  return one === 0 ? tens[ten] : `${tens[ten]} ${ones[one]}`;
}

export const paymentTerms = Array.from({ length: 100 }, (_, i) => {
  const number = i + 1;
  const word = numberToWords(number);

  return {
    label: `${word} Installment${number > 1 ? "s" : ""}`,
    value: number,
  };
});
